import { createElement, installComponent } from '../utils/createElement';
import { BREAKPOINTS } from '../utils/breakpoints';
import { COLOR_DARK_1, COLOR_DARK_4, COLOR_WHITE, COLOR_GRAY_900 } from '../utils/colors';

export default class SideNavFooter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  get _event() {
    return new CustomEvent('quick-setup', { bubbles: true, cancelable: false, composed: true });
  }

  connectedCallback() {
    const animationSpeed = window.innerWidth <= BREAKPOINTS.md || window.innerWidth >= BREAKPOINTS.lg ? 250 : 30;

    const styles = createElement('style', null, `
      .sb-sidenav-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        background-color: ${COLOR_DARK_4};
      }

      .sb-sidenav-custom-footer {
        justify-content: unset;
        flex-direction: column;
      }

      .sb-sidenav-custom-footer-row-desktop {
        flex-direction: row;
      }

      .logout-text {
        line-height: 17px;
      }

      .sb-sidenav-logout .logout-text {
        margin-left: 0.8rem;
      }

      .sb-sidenav-vertical-separator {
        order: 1;
        border: 0.5px solid ${COLOR_GRAY_900};
        margin: 13px 0;
        line-height: 15px;
        height: 14px;
      }
      .sb-sidenav-logout {
        order: 2;
        background: ${COLOR_DARK_4};
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        color: white;
        opacity: 0.7;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        transition: all ${animationSpeed}ms ease;
        animation-fill-mode: forwards;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .sb-sidenav-logout div {
        width: 100%;
        height: 1rem;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        transition: all ${animationSpeed}ms ease;
      }
      ::slotted(sb-sidenav-quick-setup){
        flex-basis: 100%;
      }

      .sb-sidenav-footer sb-sidenav-quick-setup {
        display: flex;
      }

      .quick-actions {
        margin-left: 0.5rem;
        transition: visibility 0s, width 0.5s ease;
        visibility: visible;
      }

      .sb-sidenav-quick-setup {
        order: 0;
        background: ${COLOR_DARK_4};
        display: flex;
        align-items: center;
        box-sizing: border-box;
        cursor: pointer;
        color: white;
        opacity: 0.7;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        transition: all ${animationSpeed}ms ease;
        animation-fill-mode: forwards;
      }

      .sb-sidenav-quick-setup div {
        flex-basis: 10%;
        display: block;
        width: 1rem;
        height: 1rem;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        transition: all ${animationSpeed}ms ease;
      }

      .sb-sidenav-custom-footer-item {
        display: flex;
        align-items: center;
        transition: all 250ms ease;
        width: 256px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 7px 24px;
        color: white;
        opacity: 1;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        animation-fill-mode: forwards;
      }

      .sb-sidenav-custom-footer-item:hover {
        transition: all ${animationSpeed}ms ease;
        background: ${COLOR_DARK_1};
      }

      .sb-sidenav-icon__sprite {
        display: block;
        width: 1.125rem;
        height: 1.125rem;
        transition: all ${animationSpeed}ms ease;
      }
      .sb-sidenav-icon {
        flex-basis: 1.8rem;
        display: block;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        transition: all ${animationSpeed}ms ease;
      }

      @media only screen and (max-width: ${BREAKPOINTS.sm}px) {
        .sb-sidenav-footer {
          justify-content: space-evenly;
        }

        .sb-sidenav-footer {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }

      @media only screen and (max-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-footer {
          flex-direction: row;
          padding: 0;
          height: 48px;
          justify-content: flex-start;
        }

        .sb-sidenav-logout {
          padding-left: 28px;
        }

        .sb-sidenav-custom-footer {
          justify-content: space-between;
        }

        .sb-sidenav-custom-footer-item {
          width: 100%;
        }

        .sb-sidenav-custom-footer-column-mobile {
          flex-direction: column;
        }

        .sb-sidenav-vertical-separator {
          height: 15px;
          width: unset;
          border: 0.5px solid ${COLOR_WHITE}47;
          opacity: 1;
          margin-left: 28px;
        }

        .quick-actions {
          font-size: 1.125rem;
          white-space: nowrap;
        }

        .sb-sidenav-quick-setup {
          background: ${COLOR_DARK_4};
          padding-left: 2.2rem;
        }

        .sb-sidenav-quick-setup div {
          flex-basis: 1.4rem;
          margin-bottom: 0.1rem;
          margin-right: 0;
        }
      }

      @media only screen and (max-width: ${BREAKPOINTS.lg}px) and (min-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-footer {
          display: flex;
          flex-direction: column;
        }

        .sb-sidenav-logout div {
          visibility: unset;
        }

        .sb-sidenav-footer sb-sidenav-quick-setup {
          text-align: center;
        }

        .sb-sidenav-footer > *:not(.sb-sidenav-vertical-separator) {
          height: 48px;
        }

        .sb-sidenav-vertical-separator {
          border: 0.5px solid ${COLOR_GRAY_900};
          margin: 5px 0;
          line-height: 15px;
          height: unset;
          width: 15px;
        }
        .sb-sidenav-footer {
          flex-direction: row;
          padding: 0;
        }

        .sb-sidenav-vertical-separator {
          height: 15px;
          width: unset;
          border: 0.5px solid ${COLOR_WHITE}47;
          opacity: 1;
        }

        .sb-sidenav-quick-setup  {
          padding-left: 6px;
        }

        .quick-actions {
          margin-left: 1.2rem;
        }

        .sb-sidenav-custom-footer {
          flex-direction: column;
        }

        .sb-sidenav-custom-footer-item {
          width: 100%;
        }

        .sb-sidenav-custom-footer-row-tablet {
          flex-direction: row;
        }
      }

      @media only screen and (min-width: ${BREAKPOINTS.lg}px) {
        .sb-sidenav-logout {
          text-align: start;
          transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .sb-sidenav-logout div {
          width: unset;
        }
        .sb-sidenav-logout .logout-text {
          width: 0;
          font-size: 0;
          transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .sb-sidenav-quick-setup {
          transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .sb-sidenav-logout {
          max-width: 150px;
        }

        .sb-sidenav-logout:hover .logout-text {
          font-size: unset;
          width: 10vw;
        }

        .sb-sidenav-logout:hover div {
          margin-left: 10px;
        }

        .sb-sidenav-logout:hover ~ .sb-sidenav-quick-setup {
          font-size: 0;
        }

        .sb-sidenav-logout:hover ~ .sb-sidenav-quick-setup > div {
          margin-left: 20px;
        }

        .sb-sidenav-logout:hover ~ .sb-sidenav-vertical-separator {
          margin-left: 10px;
          margin-right: 10px;
        }
      }

      @media only screen and (max-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-logout .logout-text {
          font-size: 1.125rem;
        }

        .quick-actions {
          margin-left: 1.2rem;
        }
      }
    `);
    const quickActionsIcon = createElement('div');
    quickActionsIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 16" fill="none">
        <path d="M4.36875 13.9063L9.6 7.625H6.225L6.9 2.2625L2.15625 9.125H5.04375L4.36875 13.9063ZM3 15.5L3.75 10.25H0L6.75 0.5H8.25L7.5 6.5H12L4.5 15.5H3Z" fill="white"/>
      </svg>`;

    const quickActionsIconText = createElement('span', { class: 'quick-actions' }, 'Quick Actions');
    this.quickActions = createElement('a', { class: 'sb-sidenav-quick-setup', href: '/Home/Dashboard?quicksetup', 'data-sb-automation': 'quick-actions' }, [quickActionsIcon, quickActionsIconText]);

    this.quickActions.addEventListener('click', () => {
      // eslint-disable-next-line no-underscore-dangle
      this.dispatchEvent(this._event);
    });

    const logoutIcon = createElement('div');
    logoutIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
        <path d="M1.375 13.75C1.075 13.75 0.8125 13.6375 0.5875 13.4125C0.3625 13.1875 0.25 12.925 0.25 12.625V1.375C0.25 1.075 0.3625 0.8125 0.5875 0.5875C0.8125 0.3625 1.075 0.25 1.375 0.25H6.83125V1.375H1.375V12.625H6.83125V13.75H1.375ZM10.4875 10.2812L9.68125 9.475L11.5938 7.5625H5.03125V6.4375H11.5563L9.64375 4.525L10.45 3.71875L13.75 7.01875L10.4875 10.2812Z" fill="#F2F3F5"/>
      </svg>`;

    const logoutText = createElement('div', { class: 'logout-text' }, 'Logout');
    const logoutAnchor = createElement('a', { class: 'sb-sidenav-logout', href: '/app/merchant/#/Logout', 'data-sb-automation': 'Logout' }, [logoutIcon, logoutText]);
    const sideNavVerticalSeparator = createElement('div', { class: 'sb-sidenav-vertical-separator' });
    sideNavVerticalSeparator.appendChild(createElement('div'));

    const root = createElement('div', { class: 'sb-sidenav-footer' }, [logoutAnchor, sideNavVerticalSeparator, this.quickActions]);

    this.shadowRoot.append(root, styles);
  }
}
installComponent('sb-sidenav-footer', SideNavFooter);
